<template>
   <div>
     <div class=" container-fluid   ">
        <div class="llp-container-section  heightcontainer ">
       <top-header id="height2"></top-header>
      <main-menu id="height3"></main-menu>
      <!-- Start the code for this screen here -->
      <div  id="performance" class=" container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px" >
         <div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
               <div class="col">
                  <span id="prefixddlabel" class="col">
                  <b>View Assignments</b></span>
               </div>
               <div class="col">
                  <select class="form-control input-sm" v-model="selectedEmployeeId" @[change]="displaySpecialAgentSection" :disabled="salesAgentOnly">
                  <option value="-1">Select Sales Rep</option>
                  <option v-for="(option, index) in employeeList" :value="option.employeeId" :key="index">
                     {{ option.firstName }} {{ option.middleName.length !=0 ?  ',' +option.middleName : ''}} , {{ option.lastName }}
                  </option>
                  </select>
               </div>
            </div>
            <br>
            <div  v-if="selectedEmployeeId != -1">
               <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b>Assigned Dealers</b></span></nav>
               <div>

                     <div class="row mt-2 justify-content-center mb-5">
                <div class="col">
                          <div class="table-responsive-sm table-responsive-sm mb-5 tbl-update-dealer">
                  <v-table
                    id="reviewlist"
                    :data="reviewlist"
                    class="table table-sm table-bordered table-striped"
                  >
                  <thead class="table-month-header-blue wrap-text" slot="head">
                      <v-th sortKey="selectedRegionX">Region</v-th>
                      <v-th sortKey="selectedStateX">State</v-th>
                      <v-th sortKey="selectedDealerX">Dealer Name</v-th>
                        </thead>
                      <tbody slot="body" slot-scope="{ displayData }">
                        <tr v-for="(entry,index) of displayData" :key="index">
                           <td>{{entry.selectedRegionX}}</td>
                           <td>{{entry.selectedStateX}}</td>
                           <td>{{entry.selectedDealerX}}</td>
                        </tr>
                          </tbody>
                     </v-table>
                  </div>
                </div>
                     </div>
               </div>
               <div class=" container-fluid   overflow-auto pb-4">
      <div class="llp-container-section">
                <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b>Assigned Goals</b></span></nav>
               <div class="row p-2 justify-content-center">
                   <div class="col">
                     <div class="table-responsive table-responsive-sm">
                       <table class="table table-sm table-bordered table-striped small">
                        <thead>
                  <tr class="table-month-header-red">
                     <th  colspan="2"></th>
                     <th  v-for="(m,index) in months" colspan="2"  :key="index">{{ m.value }}</th>
                  </tr>
                  <tr class="table-month-header-blue">
                     <th  v-for="(col,index) in colheaders" :key="index" v-if="col.value != 'State'">{{col.value}}</th>
                  </tr>
                        </thead>
                        <tbody>
                  <template v-for="(customer,i) in assignedgoals">
                     <template v-for="(goal, j) in customer.goals">
                        <template v-for="(subcategory, k) in goal.goalSubCategory">
                           <tr>
                              <!--td class="table-month-td" v-if="j==0 && k == 0" :rowspan="customer.span">{{customer.state}}</td-->
                              <td  v-if="k == 0" :rowspan="goal.goalSubCategory.length">{{goal.goalname}}</td>
                              <td>{{subcategory.name}}</td>
                              <template v-for="(month,k) in subcategory.monthly">
                                 <td :class="getCellColorW(k)" class="table-month-td">
                                    <center> {{month.weightage}}</center>
                                 </td>
                                 <td :class="getCellColor(k)" class="table-month-td ">
                                    <center>{{month.expected}}</center>
                                 </td>
                              </template>
                           </tr>
                        </template>
                     </template>
                  </template>
                        </tbody>
               </table>
            </div>
            <br><br>
         </div>
               </div>
            </div>
               </div>
            </div>
         </div>
      </div>
      <!-- End of the code for this screen here -->
      <bottom-footer></bottom-footer>
        </div>
     </div>
   </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import dealersjson from '../json/assigneddealers.json'
import httpemployee from '../js/http-employee.js'
// import goalsjson from '../json/assignedgoals.json'
import httpcommon from '../js/http-common.js'
export default {
   	components: {
   		MainMenu,
   		TopHeader,
   		BottomFooter
   	},
   	data () {
   		return {
   			salesAgentOnly: false,
   			assigneddealers: dealersjson,
   			assignedgoals: [],
   			employeeList: [],
   			selectedEmployeeId: '-1',
   			dealerassignmentcolnames: [],
   			months: [],
   			colheaders: [],
   			reviewlist: []
   		}
   	},
   	methods: {
   		getCellColorW: function (monthNum) {
      var currentMonth = new Date().getMonth()
      if (monthNum === currentMonth) { return 'current-month' } else if (monthNum < currentMonth) { return 'prev-month' } else { return 'future-monthw' }
   				},

   		getCellColor: function (monthNum) {
      var currentMonth = new Date().getMonth()
      if (monthNum === currentMonth) { return 'current-month' } else if (monthNum < currentMonth) { return 'prev-month' } else { return 'future-month' }
   				},
   		fetchData () {
   			this.retrieveEmployeeList()
   			httpcommon.get('/staticdata/dacolumnnames/').then(response => { this.dealerassignmentcolnames = response.data }).catch(e => { this.errorslist.push(e) })
   			httpcommon.get('/staticdata/months/').then(response => { this.months = response.data }).catch(e => { this.errorslist.push(e) })
   			httpcommon.get('/staticdata/gacolumnnames/').then(response => { this.colheaders = response.data }).catch(e => { this.errorslist.push(e) })
   				if (this.$session.get('user_role') == 'SR') {
   				this.selectedEmployeeId = this.$session.get('employee_id')
   				this.salesAgentOnly = true
   				this.displaySpecialAgentSection()
   			} else {
   				this.selectedEmployeeId = -1
   				this.salesAgentOnly = false
   			}
   		},
   		retrieveEmployeeList () {
   			httpemployee.get('/employee/salesrep').then(response => { this.employeeList = response.data }).catch(e => { this.errors.push(e) })
   		},
   		displaySpecialAgentSection: function () {
      this.reviewlist = []
      this.assignedgoals = []
      if (this.selectedEmployeeId != '-1') {
   			this.constructFixedAgentGoals()
   			httpemployee.get('/employee/' + parseInt(this.selectedEmployeeId)).then(response => {
   					 for (var i = 0; i < response.data.length; i++) {
   						var employeeobject = response.data[i]
   						for (var i = 0; i < employeeobject.empBusinessCoverageAreas.length; i++) {
   							var empbuscovarea = employeeobject.empBusinessCoverageAreas[i]
   							this.reviewlist.push({
   								'selectedRegionC': empbuscovarea.id.regionC,
   								'selectedStateC': empbuscovarea.id.stateFipsC,
   								'selectedDealerC': empbuscovarea.id.dealerId,
   								'selectedRegionX': empbuscovarea.dregion.regionX,
   								'selectedStateX': empbuscovarea.dstateFip.stateN,
   								'selectedDealerX': empbuscovarea.ddealerInfo.dealerName
   							})
   						}
   						/* if(this.reviewlist.length>0){
   							this.constructAssignGoals();
   						} */
   						var existingagentgoals = employeeobject.employeeAssignedGoals
   						if (existingagentgoals.length > 0) {
   							if (this.assignedgoals.length > 0) {
   							this.assignedgoals.forEach(agent_goal => {
   								var goals_list = agent_goal.goals
   									goals_list.forEach(agoal => {
   										var goalSubcats = agoal.goalSubCategory
   											goalSubcats.forEach(goalsubcat => {
   												goalsubcat.monthly.forEach(monthe => {
   												existingagentgoals.forEach(existingGoalobject => {
   													var frommonth = new Date(existingGoalobject.goalActiveFromMonth)
   													var monthnumber = frommonth.getMonth()

   													// var existing_statecode= (existingGoalobject.stateFipsC==null ? 'NA' : existingGoalobject.stateFipsC);
   													if ((existingGoalobject.goalSubCategoryC === goalsubcat.subcategorycode) && (this.getmonthnumber(monthe.monthName) === monthnumber)) { // && (existing_statecode===agent_goal.stateFipsCode)
   														monthe.goalId = existingGoalobject.goalId
   														monthe.weightage = existingGoalobject.weightagePct === 0 ? '' : existingGoalobject.weightagePct
   														monthe.expected = existingGoalobject.expectedCount === 0 ? '' : existingGoalobject.expectedCount
   													}
   												})
   											})
   										})
   									})
   								})
   							}
   						}
   					 }
   				}).catch(e => { console.log(e) })
   			} else {
   				this.reviewlist = []
   				this.assignedgoals = []
   			}
   		},
   		constructAssignGoals: function () {
   			/* for (var i = 0; i < this.reviewlist.length; i++) {
   				var reviewobject = this.reviewlist[i]
   				this.assignedgoals.unshift(this.constructAgentGoalObject(reviewobject.selectedStateX,reviewobject.selectedStateC))
         }; */
      this.assignedgoals.unshift(this.constructAgentGoalObject(null, null))
   			this.dynamicaRows()
   		},
   		constructAgentGoalObject (stateCode, stateId) {
   			return {
   				// state: stateCode,
   				// stateFipsCode:stateId,
   				span: 0,
   				goals: [
   				{
   					goalname: 'Dealer Transaction',
   					goalcode: 'DTX',
   					goalSubCategory: [
   					{
   						name: 'Quotes',
   						subcategorycode: 'QT',
   						monthly: [
   						{ monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
   						{ monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
   						{ monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
   						{ monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
   						{ monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
   						{ monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
   						{ monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
   						{ monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
   						{ monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
   						{ monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
   						{ monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
   						{ monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
   						]
   					},
   					{
   						name: 'Apps',
   						subcategorycode: 'APS',
   						monthly: [
   						{ monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
   						{ monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
   						{ monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
   						{ monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
   						{ monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
   						{ monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
   						{ monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
   						{ monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
   						{ monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
   						{ monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
   						{ monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
   						{ monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
   						]
   					},
   					{
   						name: 'Deals',
   						subcategorycode: 'DLS',
   						monthly: [
   						{ monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
   						{ monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
   						{ monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
   						{ monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
   						{ monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
   						{ monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
   						{ monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
   						{ monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
   						{ monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
   						{ monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
   						{ monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
   						{ monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
   						]
   					}
   					]
   				}
   				]
   			}
       	},
   		constructFixedAgentGoals () {
      this.constructAssignGoals()
          		this.assignedgoals.push({
              	// state: 'NA',
   			      // stateFipsCode:'NA',
   					 span: 0,
   					 goals: [
   						 /* {
                  goalname: 'Dealer Development',
                  goalcode: 'DD',
   							 goalSubCategory: [
   								 {
                      name: 'Active Dealer Visits',
                      subcategorycode: 'ADV',
   									 monthly: [
                       { monthName: 'Jan', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jan') },
                       { monthName: 'Feb', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Feb') },
                       { monthName: 'March', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('March') },
                       { monthName: 'April', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('April') },
                       { monthName: 'May', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('May') },
                       { monthName: 'June', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jun') },
                       { monthName: 'Jul', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jul') },
                       { monthName: 'Aug', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Aug') },
                       { monthName: 'Sep', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Sep') },
                       { monthName: 'Oct', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Oct') },
                       { monthName: 'Nov', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Nov') },
                       { monthName: 'Dec', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Dec') }
                     ]
                   },
                   {
                     name: 'New Delar Visits',
                     subcategorycode: 'NDV',
                     monthly: [
                       { monthName: 'Jan', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jan') },
                       { monthName: 'Feb', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Feb') },
                       { monthName: 'March', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('March') },
                       { monthName: 'April', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('April') },
                       { monthName: 'May', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('May') },
                       { monthName: 'June', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jun') },
                       { monthName: 'Jul', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jul') },
                       { monthName: 'Aug', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Aug') },
                       { monthName: 'Sep', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Sep') },
                       { monthName: 'Oct', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Oct') },
                       { monthName: 'Nov', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Nov') },
                       { monthName: 'Dec', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Dec') }
                     ]
                   },
                   {
                     name: 'Chip Program Enrollment',
                     subcategorycode: 'CPE',
                     monthly: [
                       { monthName: 'Jan', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jan') },
                       { monthName: 'Feb', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Feb') },
                       { monthName: 'March', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('March') },
                       { monthName: 'April', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('April') },
                       { monthName: 'May', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('May') },
                       { monthName: 'June', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jun') },
                       { monthName: 'Jul', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jul') },
                       { monthName: 'Aug', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Aug') },
                       { monthName: 'Sep', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Sep') },
                       { monthName: 'Oct', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Oct') },
                       { monthName: 'Nov', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Nov') },
                       { monthName: 'Dec', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Dec') }
                     ]
                   }
                 ]
               }, */
   						 {
            goalname: 'Dealer Goals',
            goalcode: 'DG',
   							 goalSubCategory: [
   								 {
                name: 'Existing Dealer Visits',
                subcategorycode: 'EDV',
   									 monthly: [
                  { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                  { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                  { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                  { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                  { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                  { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                  { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                  { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                  { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                  { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                  { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                  { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                ]
              },
              {
                name: 'New/Dormant Dealer Visits',
                subcategorycode: 'NDDV',
                monthly: [
                  { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                  { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                  { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                  { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                  { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                  { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                  { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                  { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                  { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                  { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                  { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                  { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                ]
              }
            ]
          },
          {
            goalname: 'Support Goals',
            goalcode: 'SG',
            goalSubCategory: [
              {
                name: 'Events',
                subcategorycode: 'ET',
                monthly: [
                  { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                  { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                  { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                  { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                  { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                  { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                  { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                  { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                  { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                  { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                  { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                  { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                ]
              },
              {
                name: 'Conferences/Auctions',
                subcategorycode: 'COAU',
                monthly: [
                  { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                  { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                  { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                  { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                  { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                  { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                  { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                  { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                  { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                  { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                  { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                  { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                ]
              },
              {
                name: 'Deal Support',
                subcategorycode: 'DSRT',
                monthly: [
                  { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                  { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                  { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                  { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                  { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                  { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                  { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                  { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                  { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                  { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                  { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                  { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                ]
              }
            ]
          }
        ]
      }
          		)
   		},
   		disableWGEXFileds: function (monthname) {
      var month_number
      switch (monthname) {
        case 'Jan':
          month_number = 0
          break
        case 'Feb':
          month_number = 1
          break
        case 'March':
          month_number = 2
          break
        case 'April':
          month_number = 3
          break
        case 'May':
          month_number = 4
          break
        case 'June':
          month_number = 5
          break
        case 'Jul':
          month_number = 6
          break
        case 'Aug':
          month_number = 7
          break
        case 'Sep':
          month_number = 8
          break
        case 'Oct':
          month_number = 9
          break
        case 'Nov':
          month_number = 10
          break
        case 'Dec':
          month_number = 11
          break
   				 default:
          month_number = 99
      }
      if (month_number < new Date().getMonth()) {
        return true
      } else {
        return false
      }
   	},
   	getmonthnumber: function (monthname) {
      var month_number
      switch (monthname) {
        case 'Jan':
          month_number = 0
          break
        case 'Feb':
          month_number = 1
          break
        case 'March':
          month_number = 2
          break
        case 'April':
          month_number = 3
          break
        case 'May':
          month_number = 4
          break
        case 'June':
          month_number = 5
          break
        case 'Jul':
          month_number = 6
          break
        case 'Aug':
          month_number = 7
          break
        case 'Sep':
          month_number = 8
          break
        case 'Oct':
          month_number = 9
          break
        case 'Nov':
          month_number = 10
          break
        case 'Dec':
          month_number = 11
          break
   				 default:
          month_number = 99
      }
      return month_number
    },
   	dynamicaRows: function () {
      let span
   		for (let i = 0; i < this.assignedgoals.length; i++) {
   			span = 0
   			for (let j = 0; j < this.assignedgoals[i].goals.length; j++) {
   				span += this.assignedgoals[i].goals[j].goalSubCategory.length
   			}
   			this.assignedgoals[i].span = span
   		}
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#performance').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
   	mounted () {
    this.fetchData()
    this.myFunction()
    this.menuheight()
   	}
}
</script>
<style scoped>
   .tddealers {
   border: 0px solid #ccc;
   text-align: left;
   border-bottom: 1px solid #eee;
   position: relative;
   font-size: 10px;
   height: 25px;
   }
   .tddealersstate{
   text-align: center;
   }
   select{
   width: 200px;
   }
   .colorblue{
   background: #cae4f5;
   }
   .colorgreen{
   background: #defae7;
   }
   .sidebyside {
   float:left;
   }
   .div-padded{
   padding-left: 15px;
   }
   .selectassign{
   padding-left: 5px;
   width: 200px;
   height: 25px;
   }
   .assign-table{
   padding-left: 60px;
   font-family: Verdana, Geneva, Tahoma, sans-serif;
   border-collapse: collapse;
   margin: 0px 0px 0px 2px;
   background-color: white;
   width: 98%;
   border-color:"#e3e4e5" ;
   }
   .future-monthw{
   background:lightseagreen;
   }
   .current-monthw{
   background: lightcyan;
   }
   .future-month{
   background: green;
   }
   .current-month{
   background: lightsalmon;
   }
   .prev-month{
   background: lightgray;
   }
</style>
